import React, {Component} from "react";
import "./GameConfigurations.component.scss";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {Subsidiary} from "../../../../../types/types";
import {ActionCreator} from "../../../../../actions/actions";
import {connect} from "react-redux";
import {gamesStoreSelectors} from "../../../store/store";
import {GamesActionCreators} from "../../../actions/actionCreators";
import {GameEngine} from "../../../reducers/gameEngines.reducer";
import {GameConfiguration} from "../../../reducers/gameConfigurations.reducer";
import Paginator from "../../../../../utils/Paginator/Paginator.component";
import GameConfigurationCard from "../GameConfigurationCard/GameConfigurationCard.component";
import Drawer from "../../../../../utils/Drawer/Drawer.component";
import CreateConfiguration from "../CreateConfiguration/CreateConfiguration.component";
import {buildGameConfigurationPayload} from "../../../utils/game-configuration-payload";
import {CreationModes} from "../../../reducers/creationMode.reducer";
import {Game} from "../../../reducers/games.reducer";
import {GameNavigation} from "../GameNavigation/GameNavigation.component";
import {checkPermission} from "../../../../../utils/Authorization/authorization";
import {withRouter, RouteComponentProps, Link} from "react-router-dom";
import {SubsidiaryUtils} from "../../../../../utils/Subsidiary/SubsidiaryUtils";
import {Dialog} from "../../../../../utils/Dialog/Dialog.component";
import {Denominations} from "../../../reducers/denominations.reducer";

export interface GameConfigurationsProps extends RouteComponentProps {
    subsidiaries: Subsidiary[];
    subsidiariesLoading: boolean;
    gameEngines: GameEngine[];
    gameEnginesLoading: boolean;
    gameConfigurations: GameConfiguration[];
    gameConfigurationsLoading: boolean;
    gameConfigurationsCount: number;
    getSubsidiaries: ActionCreator;
    getGameEngines: ActionCreator;
    getGameConfigurations: ActionCreator;
    creationMode: any;
    updateCreationMode: ActionCreator;
    clearCreateConfiguration: ActionCreator;
    getEnginesSchemas: ActionCreator;
    getGame: ActionCreator;
    gameLoading: boolean;
    game: Game;
    updateCreatingConf: ActionCreator;
    editConfiguration: ActionCreator;
    createConfiguration: ActionCreator;
    deleteConfiguration: ActionCreator;
    activateConfiguration: ActionCreator;
    searchGames: ActionCreator;
    searchGamesResults: any[];
    searchGamesLoading: boolean;
    clearSearchGames: ActionCreator;
    moveConfiguration: ActionCreator;
    getDenominations: ActionCreator;
    denominations: Denominations[];
}

export interface GameConfigurationsState {
    selectedSubsidiary: number;
    //selectedEngine: string;
    currentPage: number;
    showDialog: boolean;
    configurationToDelete: any;
    status: string;
    configToMove: any;
    showMoveDialog: boolean;
    gameToMove: number | null;
    showDuplicateDialog: boolean;
    configurationToDuplicate: any;
}

const configurationsStatus = [
    {
        value: "",
        label: "All"
    },
    {
        value: 1,
        label: "Active"
    },
    {
        value: 0,
        label: "Inactive"
    }
];

/*const engineSelectItems = gameEngines =>
    gameEngines.map(gameEngine => ({
        label: gameEngine.version,
        value: gameEngine.id
    }));*/

class GameConfigurations extends Component<
    GameConfigurationsProps,
    GameConfigurationsState
> {
    subsidiaryFilter: React.RefObject<Components.SelectMenu>;

    //engineFilter: React.RefObject<Components.SelectMenu>;

    constructor(props) {
        super(props);
        this.subsidiaryFilter = React.createRef();
        //this.engineFilter = React.createRef();

        this.state = {
            selectedSubsidiary: null,
            //selectedEngine: null,
            currentPage: 1,
            showDialog: false,
            configurationToDelete: null,
            status: "",
            configToMove: null,
            showMoveDialog: false,
            gameToMove: null,
            showDuplicateDialog: false,
            configurationToDuplicate: null
        };

        this.props.getDenominations();
    }

    componentDidMount() {
        this.props.getGameEngines();
        this.props.getSubsidiaries();
        this.props.getEnginesSchemas();

        const {params} = this.props.match;
        this.props.getGame(params["gameId"]);

        this.getGameConfigurations();
    }

    getGameConfigurations = () => {
        const {params} = this.props.match;
        this.props.getGameConfigurations({
            page: this.state.currentPage,
            top: 10,
            subsidiary: this.state.selectedSubsidiary,
            status: this.state.status,
            gameId: params["gameId"]
        });
    }

    applyFilters = (value, field) => {
        let updatedState = {...this.state};
        updatedState[field] = value
        this.setState({
            ...updatedState,
            currentPage: 1
        }, this.getGameConfigurations)
    }

    pageChange = newPage => {
        this.setState({
            currentPage: newPage
        }, this.getGameConfigurations);
    };

    onClearFilters = () => {
        this.subsidiaryFilter.current.selectItem([]);
        this.subsidiaryFilter.current.setDisplayString("Choose Subsidiary...");
        /*this.engineFilter.current.selectItem([]);
        this.engineFilter.current.setDisplayString("Choose Engine...");*/
        this.setState({
            selectedSubsidiary: null,
            status: "",
            currentPage: 1
        });
    };

    onDuplicate = conf => {
        this.setState({
            showDuplicateDialog: true,
            configurationToDuplicate: conf
        });
    };

    onDuplicateDialogConfirm = () => {
        const configuration = this.state.configurationToDuplicate;
        const {params} = this.props.match;
        const newConf = {
            game_id: parseInt(params["gameId"]),
            //engine_version_id: configuration.engine_version.id,
            subsidiary: configuration.subsidiary.id,
            label: configuration.label,
            game_category_id: configuration.game_category
                ? configuration.game_category.id
                : null,
            configuration: {
                ...configuration.configuration
                //engine: configuration.engine_version.id
            }
        };
        this.props.createConfiguration(newConf, {
            page: this.state.currentPage,
            top: 10,
            subsidiary: this.state.selectedSubsidiary,
            //gameEngine: this.state.selectedEngine,
            status: this.state.status,
            gameId: params["gameId"]
        });

        this.setState({
            showDuplicateDialog: false,
            configurationToDuplicate: null
        });
    };

    onDuplicateDialogClose = () => {
        this.setState({
            showDuplicateDialog: false,
            configurationToDelete: null
        });
    };

    onCreateSubmit = configuration => {
        const {params} = this.props.match;
        const newConf = buildGameConfigurationPayload(
            configuration,
            parseInt(params["gameId"])
        );
        this.props.createConfiguration(newConf, {
            page: this.state.currentPage,
            top: 10,
            subsidiary: this.state.selectedSubsidiary,
            //gameEngine: this.state.selectedEngine,
            status: this.state.status,
            gameId: params["gameId"]
        });
    };

    onEditSubmit = configuration => {
        const {params} = this.props.match;
        const altConf = buildGameConfigurationPayload(
            configuration,
            parseInt(params["gameId"])
        );
        this.props.editConfiguration(altConf, {
            page: this.state.currentPage,
            top: 10,
            subsidiary: this.state.selectedSubsidiary,
            //gameEngine: this.state.selectedEngine,
            status: this.state.status,
            gameId: params["gameId"]
        });
    };

    onDialogClose = () => {
        this.setState({
            showDialog: false,
            configurationToDelete: null
        });
    };

    onDeleteConfiguration = configurationToDelete => {
        this.setState({
            showDialog: true,
            configurationToDelete
        });
    };

    onDialogConfirm = () => {
        const {params} = this.props.match;

        this.props.deleteConfiguration(this.state.configurationToDelete.id, {
            page: this.state.currentPage,
            top: 10,
            subsidiary: this.state.selectedSubsidiary,
            //gameEngine: this.state.selectedEngine,
            gameId: params["gameId"]
        });

        this.setState({
            showDialog: false,
            configurationToDelete: null
        });
    };

    renderBreadcrumb = () => {
        return (
            <div className="games-breadcrumb">
                <ul>
                    <li>
                        <Link to="/games/">Games</Link>
                    </li>
                    <span className="icon-chevron-right-light"></span>
                    {this.props.game && (
                        <li className="current">{this.props.game.name}</li>
                    )}
                </ul>
            </div>
        );
    };

    renderConfigs() {
        if (this.props.gameConfigurationsLoading) {
            return (
                <div className="configurations-loading">
                    <Components.LoadingRipple
                        width={"100px"}
                        height={"100px"}
                    />
                </div>
            );
        }

        if (this.props.gameConfigurationsCount === 0) {
            return (
                <div className="configurations-list-no-games">
                    No games to display. Please select different values to try
                    again.
                </div>
            );
        } else {
            let engine = this.props.gameEngines.filter(engine => {
                return engine.id == 1;
            })[0];

            return (
                <React.Fragment>
                    <div className="cards-container">
                        {this.props.gameConfigurations.map(
                            (configuration, key) => {
                                return (
                                    <GameConfigurationCard
                                        key={key}
                                        subsidiaries={this.props.subsidiaries}
                                        gameConfiguration={configuration}
                                        edit={this.editConf}
                                        move={this.moveConf}
                                        duplicate={this.onDuplicate}
                                        delete={this.onDeleteConfiguration}
                                        activate={this.setActiveConfiguration}
                                        engine={engine}
                                        deprecated={this.props.game.deprecated}
                                        denominations={this.props.denominations}
                                    />
                                );
                            }
                        )}
                    </div>

                    <div className="col-12 paginator-col">
                        <Paginator
                            currentPage={this.state.currentPage}
                            totalPages={Math.max(
                                1,
                                Math.floor(
                                    this.props.gameConfigurationsCount / 10
                                )
                            )}
                            onPageChange={this.pageChange}
                        />
                    </div>
                    <Dialog
                        open={this.state.showDialog}
                        onConfirm={this.onDialogConfirm}
                        onClose={this.onDialogClose}
                    >
                        You are about to delete a Game Configuration. Are you
                        sure?
                    </Dialog>
                    <Dialog
                        open={this.state.showDuplicateDialog}
                        onConfirm={this.onDuplicateDialogConfirm}
                        onClose={this.onDuplicateDialogClose}
                    >
                        You are about to duplicate this Game Configuration. Are
                        you sure?
                    </Dialog>
                    <Dialog
                        open={this.state.showMoveDialog}
                        onConfirm={this.onMoveDialogConfirm}
                        onClose={this.onMoveDialogClose}
                        validSubmit={
                            this.props.searchGamesResults.length > 0 &&
                            !this.props.searchGamesLoading &&
                            this.state.gameToMove !== null
                        }
                        confirmLabel={"Confirm Move"}
                        addedClassName={"game-move"}
                    >
                        <div className="game-move-search">
                            <input
                                key={
                                    this.state.configToMove
                                        ? this.state.configToMove.id
                                        : "empty"
                                }
                                placeholder="Search new Game for config..."
                                onInput={e => {
                                    this.props.searchGames(
                                        e.currentTarget.value
                                    );
                                }}
                            />
                            <i className="icon-search-light"/>
                        </div>
                        <div className="search-games-result">
                            {!this.props.searchGamesLoading &&
                                this.props.searchGamesResults.map(game => {
                                    return (
                                        <div
                                            key={game.id}
                                            onClick={() =>
                                                this.selectMoveGame(game.id)
                                            }
                                            className={`${this.state.gameToMove == game.id
                                                ? "active"
                                                : ""
                                            }`}
                                        >
                                            <div
                                                className="game-image"
                                                style={{
                                                    backgroundImage: `url("${window.location.protocol}//${window.location.hostname}${game.image}")`
                                                }}
                                            ></div>
                                            <div className="game-info">
                                                <input
                                                    disabled
                                                    alt={game.name}
                                                    value={game.name}
                                                />
                                                <p>
                                                    {game.software_house ==
                                                    "fbm_brasil"
                                                        ? "FBM Brasil"
                                                        : "Fabamaq"}{" "}
                                                    /{" "}
                                                    {game.type !== null
                                                        ? game.type == 0
                                                            ? "Bingo"
                                                            : "Spins"
                                                        : "-"}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                            {!this.props.searchGamesLoading &&
                                this.props.searchGamesResults.length == 0 && (
                                    <p className="no-games-found">
                                        No games found.
                                    </p>
                                )}
                            {this.props.searchGamesLoading && (
                                <div className="loading" key="loading">
                                    <Components.LoadingRipple
                                        width={100}
                                        height={100}
                                    />
                                </div>
                            )}
                        </div>
                    </Dialog>
                </React.Fragment>
            );
        }
    }

    setActiveConfiguration = id => {
        const {params} = this.props.match;
        this.props.activateConfiguration(id, {
            page: this.state.currentPage,
            top: 10,
            subsidiary: this.state.selectedSubsidiary,
            //gameEngine: this.state.selectedEngine,
            status: this.state.status,
            gameId: params["gameId"]
        });
    };

    closeCreateConf = () => {
        this.props.clearCreateConfiguration();
    };

    createConf = () => {
        this.props.clearCreateConfiguration();
        this.props.updateCreationMode(CreationModes.ADD_CONFIGURATION);
    };

    editConf = conf => {
        let configuration = {...conf.configuration};
        configuration.id = conf.id;
        //configuration.engine = conf.engine_version.id;
        configuration.subsidiary = conf.subsidiary;
        configuration.label = conf.label;
        configuration.image = conf.image;
        configuration.use_main_logo = conf.image == null;
        configuration.game_category = conf.game_category || null;
        this.props.clearCreateConfiguration();
        this.props.updateCreatingConf(configuration, true);
        this.props.updateCreationMode(CreationModes.EDIT_CONFIGURATION);
    };

    moveConf = conf => {
        this.setState({
            showMoveDialog: true,
            configToMove: conf
        });
    };

    onMoveDialogClose = () => {
        this.setState({
            showMoveDialog: false,
            configToMove: null,
            gameToMove: null
        });
        this.props.clearSearchGames();
    };

    onMoveDialogConfirm = () => {
        const {params} = this.props.match;

        this.props.moveConfiguration(
            this.state.configToMove,
            this.state.gameToMove,
            {
                page: this.state.currentPage,
                top: 10,
                subsidiary: this.state.selectedSubsidiary,
                //gameEngine: this.state.selectedEngine,
                gameId: params["gameId"]
            }
        );

        this.setState({
            showMoveDialog: false,
            configToMove: null,
            gameToMove: null
        });

        this.props.clearSearchGames();
    };

    selectMoveGame = gameId => {
        this.setState({
            gameToMove: gameId
        });
    };

    render() {
        const isLoading =
            this.props.gameEnginesLoading ||
            this.props.subsidiariesLoading ||
            this.props.gameLoading;

        if (isLoading) {
            return (
                <div id="GameConfigurations" className="content">
                    <div className="configurations-list-loading">
                        <Components.LoadingRipple
                            width={"100px"}
                            height={"100px"}
                        />
                    </div>
                </div>
            );
        } else if (Object.keys(this.props.game).length === 0) {
            return (
                <div id="GameConfigurations" className="visible">
                    <div className="configurations-list-no-games">
                        Game does not exist.
                    </div>
                </div>
            )
        }

        return (
            <div id="GameConfigurations" className="content">
                <GameNavigation altMenu={this.renderBreadcrumb()}>
                    <div className="add-menu">
                        {checkPermission("edit_game_configs") && (
                            <a
                                className="new-game red-btn"
                                onClick={this.createConf}
                            >
                                <span>New Configuration</span>
                            </a>
                        )}
                    </div>
                </GameNavigation>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="hall-filters">
                                <div id="GamesPageFiltersBox">
                                    <div className="row">
                                        <div className="adjustable-filters">
                                            <div className="game-filter">
                                                <label className="label">
                                                    Subsidiaries
                                                </label>
                                                <Components.SelectMenu
                                                    key={`${this.state.selectedSubsidiary}`}
                                                    ref={this.subsidiaryFilter}
                                                    items={
                                                        this.props
                                                            .subsidiaries &&
                                                        this.props.subsidiaries
                                                            .length > 0
                                                            ? SubsidiaryUtils.subsidiarySelectItems(
                                                                this.props
                                                                    .subsidiaries
                                                            )
                                                            : []
                                                    }
                                                    noValueLabel="Choose Subsidiary..."
                                                    value={
                                                        this.state
                                                            .selectedSubsidiary ||
                                                        null
                                                    }
                                                    onChange={event => this.applyFilters(event, 'selectedSubsidiary')}
                                                    multipleSelection
                                                />
                                            </div>

                                            {/*<div className="game-filter">
                                                <label className="label">
                                                    Game Engine
                                                </label>
                                                {<Components.SelectMenu
                                                    ref={this.engineFilter}
                                                    items={
                                                        this.props
                                                            .gameEngines &&
                                                        this.props.gameEngines
                                                            .length > 0
                                                            ? engineSelectItems(
                                                                  this.props
                                                                      .gameEngines
                                                              )
                                                            : []
                                                    }
                                                    noValueLabel="Choose Engine..."
                                                    value={
                                                        this.state
                                                            .selectedEngine ||
                                                        null
                                                    }
                                                    onChange={
                                                        this.selectGameEngine
                                                    }
                                                    multipleSelection
                                                />
                                                </div>*/}

                                            <div className="game-filter configuration">
                                                <label className="label">
                                                    Configuration Status
                                                </label>
                                                <Components.CheckboxGroup
                                                    key={`checkbox-${this.state.status}`}
                                                    items={configurationsStatus}
                                                    selected={this.state.status}
                                                    onChange={event => this.applyFilters(event, 'status')}
                                                />
                                            </div>

                                            <div>
                                                <button
                                                    className="clear-filters-btn"
                                                    onClick={
                                                        this.onClearFilters
                                                    }
                                                >
                                                    Clear All Filters
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="configurations-list-card">
                            <div className="configurations">
                                <div className="row">
                                    {this.renderConfigs()}
                                </div>
                            </div>
                        </div>
                    </div>
                    {(this.props.creationMode ==
                        CreationModes.ADD_CONFIGURATION ||
                        this.props.creationMode ==
                        CreationModes.EDIT_CONFIGURATION) && (
                        <Drawer
                            title={
                                this.props.creationMode ==
                                CreationModes.ADD_CONFIGURATION
                                    ? "New Configuration"
                                    : "Edit Configuration"
                            }
                            onClose={this.closeCreateConf}
                        >
                            <CreateConfiguration
                                editConf={this.onEditSubmit}
                                createConf={this.onCreateSubmit}
                            />
                        </Drawer>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    subsidiaries: gamesStoreSelectors.subsidiaries(state),
    subsidiariesLoading: gamesStoreSelectors.subsidiariesLoading(state),
    gameEngines: gamesStoreSelectors.gameEngines(state),
    gameEnginesLoading: gamesStoreSelectors.gameEnginesLoading(state),
    gameConfigurations: gamesStoreSelectors.gameConfigurations(state),
    gameConfigurationsLoading:
        gamesStoreSelectors.gameConfigurationsLoading(state),
    gameConfigurationsCount: gamesStoreSelectors.gameConfigurationsCount(state),
    creationMode: gamesStoreSelectors.creationMode(state),
    game: gamesStoreSelectors.game(state),
    gameLoading: gamesStoreSelectors.gameLoading(state),
    searchGamesResults: gamesStoreSelectors.searchGames(state),
    searchGamesLoading: gamesStoreSelectors.searchGamesLoading(state),
    denominations: gamesStoreSelectors.denominations(state)
});

const mapDispatchToProps = {
    getSubsidiaries: GamesActionCreators.getSubsidiaries,
    getGameEngines: GamesActionCreators.getGameEngines,
    getGameConfigurations: GamesActionCreators.getGameConfigurations,

    updateCreationMode: GamesActionCreators.updateCreationMode,
    clearCreateConfiguration: GamesActionCreators.clearCreateConfiguration,
    getEnginesSchemas: GamesActionCreators.getEnginesSchemas,
    getGame: GamesActionCreators.getGame,
    updateCreatingConf: GamesActionCreators.updateCreatingConf,
    createConfiguration: GamesActionCreators.createConfiguration,
    editConfiguration: GamesActionCreators.editConfiguration,
    deleteConfiguration: GamesActionCreators.deleteConfiguration,
    activateConfiguration: GamesActionCreators.activateConfiguration,
    searchGames: GamesActionCreators.searchGames,
    clearSearchGames: GamesActionCreators.clearSearchGames,
    moveConfiguration: GamesActionCreators.moveConfiguration,
    getDenominations: GamesActionCreators.getDenominations
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(GameConfigurations));
